module.exports = __webpack_public_path__ + "img/poster2.74e106de.jpg";